/**
 * Created by jonas on 2021-02-19.
 */
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DasUBoot} from "../DasUBoot";
import {gsap} from "gsap";
import {DasUBootRoundType} from "../server/DasUBootData";
import {ModeTransition, TextSpriteTexture} from "../view/ModeTransitionScreen";
import {DasUBootMusic, DasUBootSound} from "../sound/DasUBootSound";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";


export class ShowEndScreen implements SimplePresentation {

    private shouldRunCallback:() => boolean;

    constructor(shouldRun:() => boolean) {
        this.shouldRunCallback = shouldRun;
    }

    start(controller:SimplePresentationRunnerController):void {
        let translation = DasUBoot.apiPlugin.translations.translate("YOU WON");
        const winRatio = DasUBoot.model.gameData.accumulatedRoundWin / DasUBoot.model.gameData.playedBetValue;
        let countUpDuration:number = 0.4;
        let endSound = DasUBootSound.COUNT_UP_END_MEDIUM;
        if (winRatio <= 1 || DasUBoot.isWinBelowStake()) {
            endSound = "";
            countUpDuration = 0;
        } else if (winRatio > 5) {
            endSound = DasUBootSound.COUNT_UP_END_LARGE;
            countUpDuration = 2;
        }


        const tl:gsap.core.Timeline = gsap.timeline();


        if (DasUBoot.model.winCapReached) {
            countUpDuration = 7.5;
            //translation = DasUBoot.apiPlugin.translations.translate("DAS GOLD DES ROTER TEUFEL");
            translation = "";
            let transitionMode = ModeTransition.MAX_WIN;

            DasUBoot.transitionScreen.setText(`${translation}`);
            DasUBoot.transitionScreen.setTextSprite(TextSpriteTexture.NONE);

            tl.add(() => DasUBoot.soundPlayer.playMaxWinSound());
            tl.add(DasUBoot.transitionScreen.show(transitionMode, false));
            tl.add(DasUBoot.reelView.reelFrame.showCover(), "<");

            tl.add(DasUBoot.winView.getWinCountUp(0, DasUBoot.model.gameData.accumulatedRoundWin, countUpDuration, 0, new PIXI.Point(360, 360), true));
            tl.add(DasUBoot.winView.getWinCountUpEnd(DasUBoot.model.gameData.accumulatedRoundWin, 0.01));
            tl.add(() => DasUBoot.soundPlayer.playSound(DasUBootSound.MAX_WIN_MUSIC, 1, -1));
            tl.add(() => SlotGame.keypadPlugin.setWin(DasUBoot.model.gameData.accumulatedRoundWin, true, DasUBoot.isWinBelowStake()));

            tl.add(DasUBoot.winView.getCountUpScaleAnimation(0, DasUBoot.model.gameData.accumulatedRoundWin, tl.duration(), 0.6, 0.8), 0);
            tl.add(DasUBoot.winView.getMaxWinAnimation(tl.duration()), 0);
            tl.add(() => DasUBoot.transitionScreen.enableButton(() => this.endMaxWin(controller)));

            tl.add(DasUBoot.winView.getCountUpScaleAnimation(DasUBoot.model.gameData.accumulatedRoundWin, DasUBoot.model.gameData.accumulatedRoundWin, 0.05, 0.8, 1.0));


        }
        else {
            if (winRatio <= 1 || DasUBoot.isWinBelowStake()){
                translation = "• • •  ▬ • ▬ •  • • • •  •  • •  • • •  • • •  • ";
            }
            DasUBoot.transitionScreen.setText(`${translation}`);
            DasUBoot.transitionScreen.setTextSprite(TextSpriteTexture.NONE);

            let transitionMode = DasUBoot.model.data.roundType == DasUBootRoundType.SUPER_FREE_SPIN ? ModeTransition.SUPER_FREE_SPIN : ModeTransition.FREE_SPIN;
            if (DasUBoot.model.winCapReached) {
                transitionMode = ModeTransition.MAX_WIN;
            }

            tl.add(()=>DasUBoot.soundPlayer.playSound(DasUBootSound.FS_OUTRO_SWEEP));
            tl.add(DasUBoot.transitionScreen.show(transitionMode, false));
            tl.add(DasUBoot.reelView.reelFrame.showCover(), "<");
            tl.add(() => DasUBoot.soundPlayer.playFsOutro(), "<+0.5");

            if (winRatio <= 1 || DasUBoot.isWinBelowStake()){
                tl.add(() => DasUBoot.soundPlayer.playSound(DasUBootSound.SCHEISSE_MORSE, 1,-1), "<+0.5");
            }


            tl.add(() => controller.setSkipCallback(() => tl.seek("ending", false)));
            tl.add(DasUBoot.winView.getWinCountUp(0, DasUBoot.model.gameData.accumulatedRoundWin, countUpDuration, 0, new PIXI.Point(360, 500)));
            tl.add(DasUBoot.winView.getWinCountUpEnd(DasUBoot.model.gameData.accumulatedRoundWin, 0.01, 0, endSound));
            tl.add(DasUBoot.winView.getCountUpScaleAnimation(0, DasUBoot.model.gameData.totalSpinWinnings, tl.duration(), 0.4, 0.5), 0);

            tl.addLabel("ending");
            tl.add(() => controller.setSkipCallback());


            if (DasUBoot.model.data.roundType != DasUBootRoundType.NORMAL) {
                tl.add(() => DasUBoot.reelView.reInitReels(DasUBoot.model.reelsEnteringFreespin));
            }
            tl.add(() => DasUBoot.transitionScreen.enableButton(() => this.endNormal(controller)));
        }


    }


    private endNormal(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish()});
        tl.add([
            () => DasUBoot.model.resetFeatureBuy(), //resetBuyFeatureName
            () => DasUBoot.soundPlayer.fadeAndStop(DasUBootSound.FS_OUTRO, 500),
            () => DasUBoot.soundPlayer.stopSound(DasUBootSound.MAX_WIN_MUSIC),
            () => DasUBoot.soundPlayer.stopSound(DasUBootSound.SCHEISSE_MORSE),
            DasUBoot.reelView.reelFrame.hideCover(),
            DasUBoot.transitionScreen.hide(),
            DasUBoot.winView.getWinCountUpFade(DasUBoot.model.gameData.accumulatedRoundWin),
            DasUBoot.backgroundElements.setMode(DasUBootRoundType.NORMAL, 0.5),
            () => DasUBoot.soundPlayer.switchMusic(DasUBootMusic.MAIN_GAME_MUSIC),
            () => DasUBoot.soundPlayer.fadeInMusic(1500),
        ]);

    }

    private endMaxWin(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish()});
        tl.add([
            () => DasUBoot.model.resetFeatureBuy(), //resetBuyFeatureName
            () => DasUBoot.winView.getMaxWinEnd(),
            () => DasUBoot.soundPlayer.stopSound(DasUBootSound.MAX_WIN_MUSIC),
            () => DasUBoot.soundPlayer.playSound(DasUBootSound.MAX_WIN_MUSIC_ENDS),
            DasUBoot.reelView.reelFrame.hideCover(),
            DasUBoot.transitionScreen.hide(),
            DasUBoot.winView.getWinCountUpFade(DasUBoot.model.gameData.accumulatedRoundWin),
            DasUBoot.backgroundElements.setMode(DasUBootRoundType.NORMAL, 0.5),
            () => DasUBoot.soundPlayer.switchMusic(DasUBootMusic.MAIN_GAME_MUSIC),
            () => DasUBoot.soundPlayer.fadeInMusic(1500),
        ]);

    }

    shouldRun():boolean {
        return this.shouldRunCallback();
    }
}